module.exports = __webpack_public_path__ + "static/media/SignIn_background.5eb8434a.jpg";